import fpSet from 'lodash/fp/set';

import { API_STATUS } from '~/common/constants';

import lang from '../language.json';
import TYPES from './types';

const initialState = {
  onInit: true,
  selectedCategory: 0,
  navClickedSelectedCategory: null,
  selectedAlert: { ruleResultId: null },
  selectedAlertParent: { ruleResultId: null },
  shouldGetNextAlert: false,
  isLastAlert: false,
  isUnderwriterCheckboxDisabled: false,
  allRequiredRulesCompleted: null,
  loanLockInformation: {
    loanLockedBy: null,
    isLoanCurrentlyLocked: false,
  },
  latestSignalRNotification: {
    notificationType: null,
    correlationId: null,
    receivedDateTime: null,
  },
  navigationItems: {
    allAlerts: [],
    categories: [],
    status: null,
    error: null,
  },
  triggerRules: {
    status: null,
    error: null,
    rulesTriggered: false,
  },
  user: {
    status: null,
    error: null,
    hasAccessToUnderwriterView: false,
    canWriteUnderwriterCheckbox: false,
    canOverrideAmcCheckbox: false,
  },
};

const homeReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case TYPES.SET_ON_INIT:
      return {
        ...state,
        onInit: action.value,
      };
    case TYPES.SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.category,
      };
    case TYPES.SET_CLICKED_SELECTED_CATEGORY:
      return {
        ...state,
        navClickedSelectedCategory: action.category,
      };
    case TYPES.SET_SELECTED_ALERT:
      return {
        ...state,
        selectedAlert: action.alert,
      };
    case TYPES.SET_SELECTED_ALERT_AND_CATEGORY:
      return {
        ...state,
        selectedAlert: action.alert,
        selectedCategory: action.category,
      };
    case TYPES.SET_SELECTED_ALERT_PARENT:
      return {
        ...state,
        selectedAlertParent: action.alert,
      };

    case TYPES.SET_IS_LAST_ALERT:
      return {
        ...state,
        isLastAlert: action.value,
      };
    case TYPES.SET_IS_UNDERWRITER_CHECKBOX_DISABLED:
      return {
        ...state,
        isUnderwriterCheckboxDisabled: action.value,
      };

    case TYPES.SET_UNDERWRITER_VIEW_PERMISSIONS:
      return {
        ...state,
        user: {
          ...state.user,
          hasAccessToUnderwriterView:
            action.payload?.hasAccessToUnderwriterView ||
            state.user.isUnderwriter,
          canWriteUnderwriterCheckbox:
            action.payload?.canWriteUnderwriterCheckbox ||
            state.user.isUnderwriter,
          canOverrideAmcCheckbox:
            action.payload?.canOverrideAmcCheckbox || false,
        },
      };
    case TYPES.SET_UNDERWRITER_VERIFIED_RULE:
      return fpSet(`FEVerified`, action.FEVerified, state);
    case TYPES.POST_SAVE_UNDERWRITER_VERIFICATION_STARTED:
      return {
        ...state,
        user: {
          ...state.user,
          status: API_STATUS.UPDATING,
        },
      };
    case TYPES.POST_SAVE_UNDERWRITER_VERIFICATION_ERROR:
      return {
        ...state,
        user: {
          ...state.user,
          status: null,
          error: action.error,
        },
      };
    case TYPES.POST_SAVE_UNDERWRITER_VERIFICATION_SUCCESS: {
      const newState = fpSet(`user.status`, null, state);
      const clearedState = fpSet(`user.error`, null, newState);
      if (state.selectedAlert?.ruleResultId === action.ruleResultID) {
        return fpSet(
          `selectedAlert.isUnderwriterVerified`,
          action.isUnderwriterVerified,
          clearedState,
        );
      }
      return clearedState;
    }
    case TYPES.POST_GET_UNDERWRITER_VERIFICATION_STATUS_STARTED:
      return {
        ...state,
        user: {
          ...state.user,
          status: API_STATUS.GETTING,
        },
      };
    case TYPES.POST_GET_UNDERWRITER_VERIFICATION_STATUS_ERROR:
      return {
        ...state,
        user: {
          ...state.user,
          status: null,
          error: action.error,
        },
      };
    case TYPES.POST_GET_UNDERWRITER_VERIFICATION_STATUS_SUCCESS:
      return { ...state };
    case TYPES.SET_SHOULD_GET_NEXT_ALERT:
      return {
        ...state,
        shouldGetNextAlert: action.value,
      };
    case TYPES.GET_NAVIGATION_ITEMS_STARTED:
      return {
        ...state,
        navigationItems: {
          ...state.navigationItems,
          status: API_STATUS.GETTING,
        },
      };
    case TYPES.GET_NAVIGATION_ITEMS_SUCCESS:
      return {
        ...state,
        allRequiredRulesCompleted: action.allRequiredRulesCompleted,
        loanLockInformation: action.loanLockInformation,
        navigationItems: {
          ...state.navigationItems,
          status: null,
          categories: action.categories,
          allAlerts: action.allAlerts,
        },
      };
    case TYPES.GET_NAVIGATION_ITEMS_ERROR:
      return {
        ...state,
        navigationItems: {
          ...state.navigationItems,
          status: null,
          error: action.error,
        },
      };
    case TYPES.POST_TRIGGER_ALL_RULES_STARTED:
      return {
        ...state,
        triggerRules: {
          ...state.triggerRules,
          status: API_STATUS.UPDATING,
        },
      };
    case TYPES.POST_TRIGGER_ALL_RULES_SUCCESS:
      return {
        ...state,
        triggerRules: {
          ...state.triggerRules,
          status: null,
          error: null,
          rulesTriggered: true,
        },
      };
    case TYPES.POST_TRIGGER_ALL_RULES_ERROR:
      return {
        ...state,
        triggerRules: {
          ...state.triggerRules,
          status: null,
          error: lang.POST_TRIGGER_ALL_RULES_ERROR_MESSAGE,
        },
      };
    default:
      return state;
  }
};

export default homeReducer;
